import { gql } from '@apollo/client';

const sowStatusesFragment = gql`
  fragment SowStatusesFields on SowStatus {
    Id
    AtmInfo {
      Name
      TypeDisplayName
    }
    ContractTypes
    ContractStatus
    StatusType
    ContractDate
  }
`;

export default sowStatusesFragment;
